import React from 'react';
import { Button, Icon } from '@kontentino/ui';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { useTranslation } from 'react-i18next';
import InstagramAudioConnectProfileNotice from '../InstagramAudioConnectProfileNotice';
import { isProfileConnectionError } from '../../utils/instagramAudioError';
import type { InstagramAudioErrorCode } from '../../types';

interface InstagramAudioTrackListErrorProps {
  pageId: number;
  errorCode: InstagramAudioErrorCode | null;
  canPromptConnection: boolean;
  onRetry: () => void;
}

const InstagramAudioTrackListError = ({
  pageId,
  errorCode,
  canPromptConnection,
  onRetry,
}: InstagramAudioTrackListErrorProps) => {
  const { t } = useTranslation();

  if (canPromptConnection && isProfileConnectionError(errorCode)) {
    return (
      <div className="tw-py-6">
        <InstagramAudioConnectProfileNotice
          pageId={pageId}
          errorCode={errorCode}
        />
      </div>
    );
  }

  return (
    <div
      className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-p-8 tw-text-center"
      data-cy="instagram-audio_error-state"
    >
      <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-danger-10">
        <Icon
          icon={faTriangleExclamation}
          className="tw-text-danger-100"
          size="lg"
        />
      </div>
      <p className="tw-text-sm tw-font-medium tw-text-grayscale-180">
        {errorCode === 'remote_unavailable'
          ? t('instagramAudio.temporarilyUnavailable')
          : t('somethingWentWrong')}
      </p>
      <Button
        variant="secondary"
        size="small"
        onClick={onRetry}
        data-cy="instagram-audio_retry-button"
      >
        {t('instagramAudio.tryAgain')}
      </Button>
    </div>
  );
};

export default InstagramAudioTrackListError;
